import {
  IonContent,
  IonModal,
  IonPage,
  useIonViewDidLeave,
} from "@ionic/react";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory, useLocation, withRouter } from "react-router";
import { CircularProgress } from "@mui/material";
import moment from "moment";

import ServiceDetails from "./components/serviceDetails";
import { BookingForSectionContent } from "./components/bookingForSection";
import { NavigoFinalSectionContent } from "./components/navigoFinalSection";
import NavigoFirstSection from "./components/navigoFirstSection";
import NavigoFirstSection5 from "./components/navigoFirstSection5";
import NavigoFirstSection2 from "./components/navigoFirstSection2";
import NavigoFirstSection3 from "./components/navigoFirstSection3";
import NavigoFirstSection4 from "./components/navigoFirstSection4";
import NavigoFirstSection6 from "./components/navigoFirstSection6";
import NavigoFirstSection7 from "./components/navigoFirstSection7";
import NavigoFirstSection8 from "./components/navigoFirstSection8";
import ErrorComponent from "../../components/common/ErrorComponent";
import NavigoDrawerSection from "./components/navigoDrawerSection";
import { useDispatch, useSelector } from "react-redux";
import { getFamilyData, getFamilyRelations } from "../familyInfo/familySlice";
import {
  clearAppointmentAndServices,
  getAllAppointments,
  getAllServices,
  getAllPlans,
  getPlanService,
  navigoClearError,
  navigoShowError,
  setStateFromPayload,
} from "./navigoSlice";
import { logEvent, logEventWithData } from "../../app/eventSlice";
import "./index.scss";
import { getExactDisplayName, getStringSlot } from "./utilityFunctions";
// import { File } from "@awesome-cordova-plugins/file";
import ZylaPay from "../../components/zylaPay/zylaPay";
import BookAfterPayment from "./components/bookAfterPayment";
import { NavContext } from "@ionic/react";
import { allRoutes } from "../../app/list";
import useUnhidePageOnEnter from "../../hooks/useUnhidePageOnEnter";
import { withFrom } from "./utils/navBack";
export default function NavigoBooking() {
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const pageRef = useUnhidePageOnEnter();
  const familyStore = useSelector((store) => store.familyInfo);
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile
  );
  const navigoStore = useSelector((store) => store.navigo);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const serviceType = queryParams.get("serviceType") || 1;
  const dispatch = useDispatch();
  const history = useHistory();
  const navContext = useContext(NavContext);
  const [pageType, setPageType] = useState(null);
  const {
    loadedFamily,
    loadedRelation,
    fetchingFamily,
    fetchingRelations,
    familyData,
    relations,
  } = familyStore;

  const { services, plans, appointments, ui, service } = navigoStore;
  const {
    error,
    errorMsg,
    currScreen,
    isErrorPositive,
    addressSelected,
    openDrawer,
    openZylaPay,
    paymentLoaderOrderId,
    openBookAfterPayment,
    loadedAppointments,
    loadedServices,
    loadedPlans,
    fetchingPlans,
    fetchingAppointments,
    fetchingServices,
    serviceTypeId,
    isUserSelectedFamily,
    currentServices,
  } = ui;

  // useEffect(() => {
  //   console.log("inside useeffect index");
  //   if (loadedPlans && plans.length > 0) {
  //     const planBody = {
  //       pageNum: 0,
  //       pageSize: 0,
  //       patientId: patientProfile.id,
  //       planId: plans[0].planId,
  //       serviceType: Number(serviceType),
  //     };

  //     dispatch(getPlanService(planBody));
  //   }
  // }, [loadedPlans, plans, dispatch]);
  useEffect(() => {
    if (
      loadedAppointments &&
      loadedServices &&
      loadedFamily &&
      loadedRelation &&
      loadedPlans
    ) {
      //new code for history replace
      const searchParams = new URLSearchParams(location.search);
      let locationState = null;
      let currentScreen = 0;
      let serviceId = -1;

      if (searchParams.has("currScreen")) {
        currentScreen = searchParams.get("currScreen");
      }
      if (searchParams.has("serviceId")) {
        serviceId = searchParams.get("serviceId");
      }

      if (searchParams.has("isFamily")) {
        let mpId = searchParams.get("memberPatientId");
        let isMember = searchParams.get("isFamily");
        let isSelectedByUser = searchParams.get("isUserSelectedFamily");
        let memberData = null;

        if (familyData && familyData.length > 0) {
          let mdata = familyData.find((ele) => ele.memberPatientId == mpId);

          if (mdata) {
            memberData = { ...mdata };
          }
        }
        if (memberData) {
          locationState = {
            memberPatientId: mpId,
            isFamily: isMember,
            memberData: memberData,
            isSelectedByUser: isSelectedByUser,
          };
        }
      }

      //end of new code

      // const locationState = location.state;
      // console.log("location state is ", location.state);
      let familyMemberSelected = -2;
      let familyMemberSelectedData = {};
      let isSelectedByUser = false;
      if (locationState && locationState.isFamily) {
        familyMemberSelected = locationState.memberPatientId;
        familyMemberSelectedData = locationState.memberData;
        isSelectedByUser = locationState.isSelectedByUser;
      }

      let token = "";
      // this.documentService.getToken((tok) => {
      //   token = tok;
      // });
      try {
        if (patientProfile && patientProfile.countryCode != "91") {
          navContext.navigate("/tab/chat", "none", "pop");
        }
      } catch (err) {}

      let members = [];

      if (familyData && familyData.length > 0) {
        members = [...familyData];
      }

      let fmArr = [];
      let fmObj = {};
      if (members && members.length > 0) {
        fmArr = members.filter((fm) => {
          return (
            fm.countryCode == "91" &&
            fm.memberPatientId !== familyMemberSelected
          );
        });
        if (familyMemberSelected !== -2) {
          fmArr = [{ ...familyMemberSelectedData }, ...fmArr];
        }
        fmArr = fmArr.map((fm) => {
          fmObj[fm.memberPatientId] = fm.firstName;
          return {
            ...fm,
            relationName: relations.entities[fm.relation]?.value,
          };
        });
      }
      let allServices = [];
      let isServicePresent = false;
      let selectedService = null;

      if (services && services.length > 0) {
        allServices = services.map((service) => {
          let afObj = {};

          let availedForArr = service.availedFor.map((af) => {
            afObj[af] = true;
            return af;
          });

          if (service.service.ID == serviceId) {
            isServicePresent = true;
            selectedService = {
              ...service.service,
              availedForFamily: service.availedForFamily,
              availed: service.availed
                ? true
                : familyMemberSelected === -2
                ? service.availed
                : afObj[familyMemberSelected]
                ? true
                : service.availedForFamily
                ? true
                : false,
              availedFor: availedForArr,
              availedForObj: afObj,
            };
          }

          return {
            ...service.service,
            availedForFamily: service.availedForFamily,
            availed: service.availed
              ? true
              : familyMemberSelected === -2
              ? service.availed
              : afObj[familyMemberSelected]
              ? true
              : service.availedForFamily
              ? true
              : false,
            availedFor: availedForArr,
            availedForObj: afObj,
          };
        });
      }
      if (familyMemberSelected !== -2) {
        allServices = allServices.filter((service) => {
          return service.availableForFamily;
        });
      }

      let pastAppoint = [];
      let upcomingAppoint = [];

      if (appointments && appointments.past && appointments.past.length > 0) {
        pastAppoint = appointments.past.map((appoint) => {
          return {
            ...appoint,
            appointment: {
              ...appoint.appointment,
              appointmentDate: moment(
                appoint.appointment.appointmentDate
              ).format("DD MMM, YYYY"),
              timeSlot: getStringSlot(appoint.appointment.timeSlot),
              displayName: getExactDisplayName(fmObj, appoint),
            },
          };
        });
      }
      if (
        appointments &&
        appointments.upcoming &&
        appointments.upcoming.length > 0
      ) {
        upcomingAppoint = appointments.upcoming.map((appoint) => {
          return {
            ...appoint,
            appointment: {
              ...appoint.appointment,
              appointmentDate: moment(
                appoint.appointment.appointmentDate
              ).format("DD MMM, YYYY"),
              timeSlot: getStringSlot(appoint.appointment.timeSlot),
              displayName: getExactDisplayName(fmObj, appoint),
            },
          };
        });
      }

      dispatch(
        setStateFromPayload({
          shouldShowBookingFor: false,
          familyMembers: fmArr,
          services: allServices,
          familyMemberSelected: familyMemberSelected,
          familyMemberSelectedData: familyMemberSelectedData,
          isForFamily: familyMemberSelected !== -2 ? true : false,
          pastAppointments: pastAppoint,
          upcomingAppointments: upcomingAppoint,
          currentServices: selectedService ? selectedService : currentServices,
          currScreen: selectedService
            ? 2
            : currentScreen
            ? Number(currentScreen)
            : currScreen,
          // This (deep-link auto-select) path is never the CMP flow; clear the
          // flag so a stale value from a prior CMP booking can't leak in.
          isCmpBooking: false,
          currentAddressSelected: null,
          drawerType: 0,
          openDrawer: false,
          token: token,
          isUserSelectedFamily: isSelectedByUser,
        })
      );

      dispatch(
        logEventWithData({
          action: "navigo_home",
          data: { is_app_event: true },
        })
      );
    } else {
      if (!loadedAppointments && !fetchingAppointments) {
        dispatch(
          getAllAppointments({
            id: patientProfile?.id,
            serviceType: serviceTypeId,
          })
        );
      }
      if (!loadedPlans && !fetchingPlans) {
        dispatch(getAllPlans({ id: patientProfile?.id }));
      }
      if (!loadedFamily && !fetchingFamily) {
        dispatch(getFamilyData());
      }
      if (!loadedRelation && !fetchingRelations) {
        dispatch(getFamilyRelations());
      }
    }
  }, [
    familyData,
    loadedAppointments,
    loadedServices,
    loadedPlans,
    loadedRelation,
    loadedFamily,
    location.search,
    fetchingFamily,
    fetchingRelations,
    fetchingAppointments,
    fetchingServices,
    fetchingPlans,
    appointments,
    services,
    plans,
    patientProfile,
    relations,
  ]);

  // useEffect(() => {
  //   if (window.Capacitor.platform !== "web") {
  //     File.removeRecursively(File.documentsDirectory, "myDownloads")
  //       .then((res) => {})
  //       .catch((err) => {});
  //   }
  //   return () => {
  //     dispatch(clearAppointmentAndServices({ serviceTypeId: serviceTypeId }));
  //   };
  // }, []);

  const lastClearedServiceTypeRef = useRef(undefined);
  useEffect(() => {
    if (location.pathname !== "/navigo") return;
    let searchParams = new URLSearchParams(location.search);
    let serviceType = null;
    if (searchParams.has("serviceType")) {
      serviceType = searchParams.get("serviceType");
    }
    if (lastClearedServiceTypeRef.current === serviceType) return;
    lastClearedServiceTypeRef.current = serviceType;
    dispatch(clearAppointmentAndServices({ serviceTypeId: serviceType }));
  }, [location.search, location.pathname]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const pageTypeFromParams = searchParams.get("pageType");

    if (pageTypeFromParams) {
      setPageType(Number(pageTypeFromParams));
    }
  }, [location.search]);

  useEffect(() => {
    let content = document.querySelector("ion-content");
    content.scrollToTop(0);
  }, [currScreen]);

  useEffect(() => {
    if (location.pathname === "/address" && addressSelected) {
      dispatch(
        setStateFromPayload({
          currScreen: 3,
        })
      );
    }
  }, [addressSelected]);

  const handleGotoAddress = useCallback(
    (pId, memberData, isUserSelectedFamily) => {
      history.push({
        pathname: "/address",
        // withFrom records THIS screen — including its query string — on the
        // way in. The address book's BackButton has no fallback of its own, so
        // without a trail it dropped to "/tab/home" instead of returning to the
        // navigo screen the deep link opened (/navigo?currScreen=1&pageType=…).
        state: withFrom(location, {
          isMember: pId !== -1 ? true : false,
          memberPatientId: pId,
          memberEmail: memberData.email,
          memberData: { ...memberData },
          isPath: true,
          isNavigo: true,
          path: "/navigo",
          isUserSelectedFamily: isUserSelectedFamily
            ? isUserSelectedFamily
            : "",
        }),
      });
    },
    // `location` must be a dependency: the empty array captured the location
    // from first render, so after a back-navigation to /navigo (this component
    // stays mounted) the trail would record a stale path.
    [location]
  );

  const handleCompletion = (result, isCancel = false) => {
    if (isCancel) {
      dispatch(
        setStateFromPayload({
          openZylaPay: false,
          paymentLoaderOrderId: "",
          openDrawer: false,
          drawerType: 0,
        })
      );
      return;
    }

    if (result) {
      dispatch(
        setStateFromPayload({
          openZylaPay: false,
          openBookAfterPayment: true,
        })
      );
    } else {
      dispatch(
        navigoShowError({ msg: "Something went wrong while making payments" })
      );
    }
  };

  const handleGoBackBooking = (arg) => {
    if (arg === 1) {
      dispatch(
        setStateFromPayload({
          currScreen: 1,
          openDrawer: false,
          openZylaPay: false,
          openBookAfterPayment: false,
        })
      );
    } else if (arg === 2) {
      dispatch(
        setStateFromPayload({
          currScreen: 1,
          addressSelected: null,
          openDrawer: false,
          openZylaPay: false,
          openBookAfterPayment: false,
        })
      );
      dispatch(logEvent({ action: `Confirm appointment` }));
      navContext.navigate("/ordercomplete?navigo=true", "none", "pop");
    }
  };

  const getPageType = () => {
    if (pageType == 2) {
      return <NavigoFirstSection2 handleGotoAddress={handleGotoAddress} />; //hra and prc
    }
    if (pageType == 3) {
      return <NavigoFirstSection3 handleGotoAddress={handleGotoAddress} />; //radiology and pathology
    }
    if (pageType == 4) {
      return <NavigoFirstSection4 handleGotoAddress={handleGotoAddress} />; //doctor consultation, Physiotherapy consultation, Psychologist consultation
    }
    if (pageType == 5) {
      return <NavigoFirstSection5 handleGotoAddress={handleGotoAddress} />; //SEWA health assesments
    }
    if (pageType == 6) {
      return <NavigoFirstSection6 handleGotoAddress={handleGotoAddress} />; //Hra on bot
    }
    if (pageType == 7) {
      return <NavigoFirstSection7 handleGotoAddress={handleGotoAddress} />; // CMP
    }
    if (pageType == 8) {
      return <NavigoFirstSection8 handleGotoAddress={handleGotoAddress} />; // second medical opinion
    }
    return <NavigoFirstSection handleGotoAddress={handleGotoAddress} />;
  };

  return (
    <IonPage ref={pageRef}>
      <IonContent style={{ "--background": "#F8F9FA" }}>
        <ErrorComponent
          show={error}
          msg={errorMsg}
          isPositive={isErrorPositive}
          errorClose={() => {
            dispatch(navigoClearError());
          }}
        />

        {currScreen === 1 && getPageType()}
        {currScreen === 2 && (
          <BookingForSectionContent handleGotoAddress={handleGotoAddress} />
        )}
        {currScreen === 3 && <NavigoFinalSectionContent />}
        {currScreen === 4 && <ServiceDetails />}
        {currScreen === 5 && (
          <div className="navigo-booking-screen-5">
            <CircularProgress className="ion-router-circular-progress "></CircularProgress>
          </div>
        )}

        {openDrawer && <NavigoDrawerSection />}
        {openZylaPay && (
          <ZylaPay
            orderId={paymentLoaderOrderId}
            openZylaPay={openZylaPay}
            handleClose={(result, isCancel = false) => {
              handleCompletion(result, isCancel);
            }}
          />
        )}
        {openBookAfterPayment && (
          <>
            {" "}
            {console.log("inside payment2", paymentLoaderOrderId)}
            <IonModal
              cssClass="navigo-booking-after-pay-modal"
              isOpen={openBookAfterPayment}
              animated={false}
            >
              <BookAfterPayment
                orderId={paymentLoaderOrderId}
                handleGoBack={(arg) => {
                  handleGoBackBooking(arg);
                }}
              />
            </IonModal>
          </>
        )}
      </IonContent>
    </IonPage>
  );
}
